import { Injectable } from '@angular/core';
import { AdHocDebtReminderModel } from "@models/reminders/ad-hoc-debt-reminder-model";
import { AdHocPaymentReminderModel } from "@models/reminders/ad-hoc-payment-reminder-model";
import { AdHocSigningReminderModel } from "@models/reminders/ad-hoc-signing-reminder-model";
import { ReminderRecord } from "@models/reminders/reminder-record";
import { CreateReminderModel } from "@models/requests/create-reminder-model";
import BaseApiService from "@shared/services/base/base-api.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class RemindersApiService extends BaseApiService {
  sendSigningAdHocReminder(body: AdHocSigningReminderModel): Observable<ReminderRecord> {
    return this.api.post<ReminderRecord>(`${ this.apiUrl }/reminders/ah-hoc/signing`, body);
  }

  sendPaymentAdHocReminder(body: AdHocPaymentReminderModel): Observable<ReminderRecord> {
    return this.api.post<ReminderRecord>(`${ this.apiUrl }/reminders/ah-hoc/payment`, body);
  }

  sendDebtAdHocReminder(body: AdHocDebtReminderModel): Observable<ReminderRecord> {
    return this.api.post<ReminderRecord>(`${ this.apiUrl }/reminders/ah-hoc/debt`, body);
  }

  addReminder(body: CreateReminderModel): Observable<ReminderRecord> {
    return this.api.post<ReminderRecord>(`${ this.apiUrl }/reminders`, body);
  }

  deleteReminder(reminderId: string): Observable<void> {
    return this.api.delete<void>(`${ this.apiUrl }/reminders/${ reminderId }`);
  }
}
